import { isDev } from '@common'

/**
 * Get the image URL prefix based on environment
 * @returns {string} The image URL prefix
 */
export const getImageUrlPrefix = () => {
    // Use environment variable if available, otherwise fallback to default
    const prefix = process.env.REACT_APP_IMAGE_URL_PREFIX

    if (prefix) {
        return prefix
    }

    // Default prefixes based on environment
    if (isDev) {
        // Dev environment prefix (update this with your actual dev prefix)
        return 'https://testlivingmenustorage.blob.core.windows.net/dishimages'
    }

    // Production environment prefix
    return 'https://lmgraphql.blob.core.windows.net/dishimages'
}

/**
 * Get the full image URL for a dish
 * @param {string|number} dishId - The dish ID
 * @returns {string} The complete image URL
 */
export const getDishImageUrl = dishId => {
    if (!dishId) {
        return ''
    }

    const prefix = getImageUrlPrefix()
    return `${prefix}/${dishId}.jpg`
}
